import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';

import FormsClaimFlex from '../../forms/claim/flex';
import FormsClaimInpatient from '../../forms/claim/inpatient';
import FormsClaimOutpatient from '../../forms/claim/outpatient';

class ClaimSubmissionInformation extends Component {
    render() {
        return (
            <Grid.Row>
                <Grid.Column>
                    {
                        (this.props.type === 'flex') ? <FormsClaimFlex submitFlexClaim={this.props.submitFlexClaim} user={this.props.user} /> : ''
                    }
                    {
                        (this.props.type === 'inpatient') &&
                        (
                            <FormsClaimInpatient
                                submitInpatientClaim={this.props.submitInpatientClaim}
                                user={this.props.user}
                                claimOptions={(this.props.claimOptions) ? this.props.claimOptions.inpatientClaimOptions : {}}
                                updateCompletedClaimData={this.props.updateCompletedClaimData}
                                configBenefit={this.props.configBenefit}
                                appLaunchConfig={this.props.appLaunchConfig}
                                getClaimOptionsEclaim={this.props.getClaimOptionsEclaim} 
                                getEclaimOptionsPageAction={this.props.getEclaimOptionsPageAction}
                                filteredByCompany={this.props.claimOptions.companyId}
                                filteredByClaimantId={this.props.claimOptions.claimantId}
                                filteredByVisitDate={this.props.claimOptions.visitDate}
                            />
                        )
                    }
                    {
                        (this.props.type === 'outpatient') &&
                        (
                            <FormsClaimOutpatient
                                submitOutpatientClaim={this.props.submitOutpatientClaim}
                                user={this.props.user}
                                claimOptions={(this.props.claimOptions) ? this.props.claimOptions.outpatientClaimOptions : {}}
                                inpatientClaimOptions={(this.props.claimOptions) ? this.props.claimOptions.inpatientClaimOptions : {}}
                                updateCompletedClaimData={this.props.updateCompletedClaimData}
                                configBenefit={this.props.configBenefit}
                                appLaunchConfig={this.props.appLaunchConfig}
                                getClaimOptionsEclaim={this.props.getClaimOptionsEclaim}
                                getEclaimOptionsPageAction={this.props.getEclaimOptionsPageAction}
                                filteredByCompany={this.props.claimOptions.companyId}
                                filteredByClaimantId={this.props.claimOptions.claimantId}
                                filteredByVisitDate={this.props.claimOptions.visitDate}
                                getClaimOptionsRequest={this.props.getClaimOptionsRequest}
                                isLoaded={this.props.isLoaded}/>
                        )
                    }
                </Grid.Column>
            </Grid.Row>
        );
    }
}

export default ClaimSubmissionInformation;
